module.exports = __webpack_public_path__ + "img/chevron-bar-contract.f949c111.svg";